import { Button, Grid } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../../components/api'

const retornaPrograma = (l = []) => ({
  idContratante: l[0],
  dsNome: l[1],
  dsResponsavel: l[2],
  nrCnpj: l[3],
  nrCpf: l[4],
  dsLogradouro: l[5],
  nrLogradouro: l[6],
  dsBairro: l[7],
  cdCep: l[8],
  dtInclusao: l[9],
  dtExclusao: l[10],
})

const Edicao = ({ programaAberto, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', {
      ...values,
      dsIcone: values.dsIcone?.icone || '',
    })
    if (res.status) voltar()
    else alert(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaPrograma(programaAberto)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="idPermissao"
                label="ID"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
              <Field
                component={TextField}
                name="dsResponsavel"
                label="Responsável"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                name="nrCpf"
                label="CPF"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                name="nrCnpj"
                label="CNPJ"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="cdCep"
                label="CEP"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
              <Field
                component={TextField}
                name="dsLogradouro"
                label="Lograduro"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="nrLogradouro"
                label="Número"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={4} xl={2}>
              <Field
                component={TextField}
                name="dsBairro"
                label="Bairro"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
